module.exports = __webpack_public_path__ + "static/media/project-soundla.fec09d69.jpg";